import { Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";
import { ArrowLeft, Download, Smartphone, Sun, Moon } from "lucide-react";
import { MetaTradifyLogo, MetaTradifyLogoSmall } from "@/components/MetaTradifyLogo";

export default function DownloadAppPage() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)]">

      {/* NAV (same as About page) */}
      <nav className="fixed top-0 w-full z-50 glass border-b border-[var(--border-subtle)]">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <MetaTradifyLogo size={32} />
            <span className="text-lg font-bold font-['Outfit'] tracking-tight">
              metaTradify
            </span>
          </Link>

          <div className="flex items-center gap-3">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-[var(--hover-bg)] border border-[var(--border-subtle)]"
            >
              {theme === "dark" ? (
                <Sun className="w-4 h-4 text-amber-400" />
              ) : (
                <Moon className="w-4 h-4 text-green-500" />
              )}
            </button>

            <Link
              to="/"
              className="flex items-center gap-1.5 px-4 py-2 text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
            >
              <ArrowLeft className="w-4 h-4" /> Back
            </Link>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="pt-28 pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">

            <h1 className="text-4xl sm:text-5xl font-bold font-['Outfit'] tracking-tight mb-5">
              Download <span className="text-green-400">MetaTradify App</span>
            </h1>

            <p className="text-base text-[var(--text-secondary)] leading-relaxed">
              Experience trading on the go with our powerful mobile app. 
              Get real-time market data, execute trades instantly, and 
              manage your portfolio anytime, anywhere with ease.
            </p>

          </div>
        </div>
      </section>

      {/* DOWNLOAD BOX */}
      <section className="px-6 pb-20">
        <div className="max-w-7xl mx-auto">

          <div className="max-w-xl mx-auto p-8 bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-xl shadow-lg text-center">

            <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-green-500/10 flex items-center justify-center">
              <Smartphone className="w-7 h-7 text-green-400" />
            </div>

            <h2 className="text-xl font-semibold font-['Outfit'] mb-2">
              Get the App
            </h2>

            <p className="text-sm text-[var(--text-secondary)] mb-6">
              Download our official app for Android & iOS and start trading instantly.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">

              <a
                href="/metaTradify.apk"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg text-sm font-medium transition-all hover:shadow-lg hover:shadow-green-500/25"
              >
                <Download className="w-4 h-4" />
                Download APK
              </a>

              <a
                href="#"
                className="flex items-center justify-center gap-2 px-6 py-3 border border-[var(--border-subtle)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] rounded-lg text-sm transition-all"
              >
                iOS Coming Soon
              </a>

            </div>

          </div>

        </div>
      </section>
   {/* Footer */}
      <footer className="border-t border-[var(--border-subtle)] py-8 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <MetaTradifyLogoSmall size={24} />
            <span className="text-sm font-semibold font-['Outfit']">metaTradify</span>
          </div>
          <div className="flex items-center gap-6 text-xs text-[var(--text-tertiary)]">
            <Link to="/about" className="hover:text-[var(--text-secondary)] transition-colors">About</Link>
            <Link to="/contact" className="hover:text-[var(--text-secondary)] transition-colors">Contact</Link>
            <Link to="/privacy-policy" className="hover:text-[var(--text-secondary)] transition-colors">Privacy</Link>
          </div>
          <p className="text-xs text-[var(--text-tertiary)]">&copy; 2025 metaTradify. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}